// import JS files
import '../kickstart';
import './countdown';
import './sticky-nav';
import './collapsible';
import { h, render } from 'preact';
import App from './locator';
import StatewideRaces from './statewide-races';

render(<App />, document.getElementById('app'));
render(<StatewideRaces />, document.getElementById('statewide__contests'));
